// @flow
import React from 'react';
import ReactDOM from 'react-dom';

import type { ScriptCommonArgs } from '../../types';

import { Footer } from '../../../components/Blocks/Footer';
import { LocaleSelect, LocaleSelectType } from '../../../ui-components/Editor/LocaleSelect';

export const localeSelect = ({
  data: {
    widgets,
    locales,
    locale,
    merchantId,
    renderMode
  }
}: ScriptCommonArgs) => {
  if (!Footer.isShowLocaleSelect(widgets.translationsLocation, locales)) {
    return;
  }

  const component = (
    <LocaleSelect
      localeList={locales}
      currentLocale={locale}
      merchantId={merchantId}
      renderMode={renderMode}
      type={LocaleSelectType.SLIM}
    />
  );
  const container = document.querySelector('[data-footer-locale-select]');
  if (!container) {
    throw new Error('Container for LocaleSelect isn\'t present on the page');
  }
  ReactDOM.render(component, container);
};
